import { useCallback, useEffect, useState } from "react";

import { employeeRequests } from "api/employeeApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

// Callers must memoize `filters` — a fresh object every render would re-fire the effect.
export const useBusinessTripTemplates = filters => {
  const notifyError = useNotifyError();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTemplates = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await dataProvider.customRequest(
        employeeRequests.getBusinessTripTemplates(filters),
        null,
        "GET",
      );
      setTemplates(data ?? []);
    } catch (err) {
      notifyError(err);
    } finally {
      setLoading(false);
    }
  }, [filters, notifyError]);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  return { templates, loading };
};
